module.exports = {
  server_url: "https://real-state-staging.herokuapp.com",
  // server_url: "https://real-state-staging.herokuapp.com/api",
  // image_url: "https://real-state-staging.herokuapp.com/",
  image_url:
    "https://res.cloudinary.com/risingpearls/image/upload/v1659163070/",
  // base_url: 'https://bluesilo-fcomm.s3.amazonaws.com/profile/',
  // base_url_new: 'https://bluesilo-fcomm.s3.amazonaws.com/',
  // stripe_publish: process.env.REACT_APP_STRIPE_PUBLISH
  // server_url: 'https://92f2-2400-adc5-1c7-6a00-7cba-cb05-aa32-5264.ngrok.io/'
};
